import type {
  EntityPalette,
  EntityPaletteColor,
  SimpleVariantColors,
  VariantColors,
} from '@components/Theme'

export function variantColorsToSimpleVariantColors(
  variantColors: VariantColors,
): SimpleVariantColors {
  return {
    dark: variantColors.dark,
    light: variantColors.light,
    main: variantColors.mid,
  }
}

export function entityColorsToSimpleVariantColors(
  palette: EntityPalette,
): Record<`entity${EntityPaletteColor}`, SimpleVariantColors> {
  return Object.entries(palette).reduce(
    (acc, [entityName, value]) => ({
      ...acc,
      [`entity${entityName}`]: value,
    }),
    {} as Record<`entity${EntityPaletteColor}`, SimpleVariantColors>,
  )
}
